<template>
  <div>
    <div class="card-title h5">7. {{ $t('tabs.transport.description') }}</div>

    <div class="form-group mb-3">
      <label class="required form-label">{{ $t('tabs.transport.question1') }}</label>
      <div class="row">
        <div class="form-check form-check-inline col col-md-3 col-lg-3" v-for="(item, index) in options_transport" :key="index">
          <input class="form-check-input" type="radio" :class="{'input': true, 'is-invalid': errors.has('transport') }"
                 name="transport"
                 v-validate="'required|included:' + options_transport.map(item => item.value)"
                 :value="item.value"
                 v-model="transport">
          <label class="form-check-label">{{ item[lang] }}</label>
        </div>
        <span class="invalid-feedback" v-show="errors.has('transport')">{{ errors.first('transport') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {list_transport} from "@/helpers/data";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Transport",
  props: { lang: { required:true, default:'ca'} },
  data() {
    return {
      transport: '',
      options_transport: list_transport
    }
  },
  created() {
    this.$validator.localize(this.lang);
  },
  methods: {
    async validate() {
      const result = await this.$validator.validateAll();
      if (!result) {
        return false;
      }
      this.$emit('on-validate', this.$data, true);
      return result;
    }
  }
}
</script>

<style scoped>

</style>